<template>
  <BApp>
    <router-view></router-view>
    <AppDialogModal></AppDialogModal>
    <BOrchestrator />
  </BApp>
</template>

<script>
import { BApp, BOrchestrator } from 'bootstrap-vue-next';
import httpStatusCodes from './utils/http-status-codes';
import AppDialogModal from '@/components/AppDialogModal.vue';
export default {
  name: 'app',
  components: {
    AppDialogModal,
    BApp,
    BOrchestrator
  },
  beforeMount () {
    this.axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (error.response && error.response.status === httpStatusCodes.UNAUTHORIZED) {
        this.$router.push('/login?expired=true');
      } else {
        return Promise.reject(error);
      }
    });
  }
};
</script>
